import create from "zustand"
import { persist } from "./persist"

export const useUser = create(
    persist({
        key: 'user', // required, child key of storage
    }, (set) => ({
        collection: [],
    }))
)